export default "__VITE_ASSET__FMBT_obU__"